import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import * as arizonaAddressesSlice from '../../../../../store/slices/addresses/arizonaAddressesSlice';
import * as nevadaAddressesSlice from '../../../../../store/slices/addresses/nevadaAddressesSlice';
import * as newMexicoAddressesSlice from '../../../../../store/slices/addresses/newMexicoAddressesSlice';
import {
  getJusticeFeesAndCosts,
  getSuperiorFeesAndCosts,
} from '../../../../../store/slices/courts/arizonaCourtsSlice';
import { getFeesAndCosts } from '../../../../../store/slices/courts/nevadaCourtsSlice';
import { getFeesAndCostsNM } from '../../../../../store/slices/courts/newMexicoCourtsSlice';

export const useStateSpecificStore = ({ stateCode }) => {
  const arizonaCourts = useSelector((state) => state.arizonaCourts);
  const nevadaCourts = useSelector((state) => state.nevadaCourts);
  const newMexicoCourts = useSelector((state) => state.newMexicoCourts);

  const data = useMemo(() => {
    if (stateCode === 'NV') {
      return {
        getFeesAndCosts,
        feesAndCosts: nevadaCourts.getFeesAndCosts,
      };
    }
    if (stateCode === 'AZ') {
      return {
        getJusticeFeesAndCosts,
        justiceFeesAndCosts: arizonaCourts.getJusticeFeesAndCosts,
        getSuperiorFeesAndCosts,
        superiorFeesAndCosts: arizonaCourts.getSuperiorFeesAndCosts,
      };
    }
    if (stateCode === 'NM') {
      return {
        getFeesAndCosts: getFeesAndCostsNM,
        feesAndCosts: newMexicoCourts.getFeesAndCosts,
      };
    }
    return {};
  }, [stateCode, arizonaCourts, nevadaCourts, newMexicoCourts]);

  return data;
};

export const useAddressStateSpecificStore = ({ stateCode }) => {
  const arizonaAddresses = useSelector((state) => state.arizonaAddresses);
  const nevadaAddresses = useSelector((state) => state.nevadaAddresses);
  const newMexicoAddresses = useSelector((state) => state.newMexicoAddresses);

  const data = useMemo(() => {
    if (stateCode === 'NV') {
      return {
        address: nevadaAddresses.getAddress,
        addressId: nevadaAddresses.addressId,
        editAddressError: nevadaAddresses.editAddressError,

        getAddress: nevadaAddressesSlice.getAddress,
        updateAddress: nevadaAddressesSlice.updateAddress,
        createAddress: nevadaAddressesSlice.createAddress,
        resetEditAddressError: nevadaAddressesSlice.resetEditAddressError,
      };
    }
    if (stateCode === 'AZ') {
      return {
        address: arizonaAddresses.getAddress,
        addressId: arizonaAddresses.addressId,
        editAddressError: arizonaAddresses.editAddressError,

        getAddress: arizonaAddressesSlice.getAddress,
        updateAddress: arizonaAddressesSlice.updateAddress,
        createAddress: arizonaAddressesSlice.createAddress,
        resetEditAddressError: arizonaAddressesSlice.resetEditAddressError,
      };
    }
    if (stateCode === 'NM') {
      return {
        address: newMexicoAddresses.getAddress,
        addressId: newMexicoAddresses.addressId,
        editAddressError: newMexicoAddresses.editAddressError,

        getAddress: newMexicoAddressesSlice.getAddress,
        updateAddress: newMexicoAddressesSlice.updateAddress,
        createAddress: newMexicoAddressesSlice.createAddress,
        resetEditAddressError: newMexicoAddressesSlice.resetEditAddressError,
      };
    }
    return {};
  }, [stateCode, nevadaAddresses, arizonaAddresses, newMexicoAddresses]);

  return data;
};
